<script>
	import { createEventDispatcher } from "svelte";
	import { Table } from "sveltestrap";
	import CustomTableLink from "./CustomTableLink.svelte";
	import CustomTableDate from "./CustomTableDate.svelte";
	import CustomTableActions from "./CustomTableActions.svelte";
	import CustomTableStatus from "./CustomTableStatus.svelte";
	import Pagination from "../CustomPaginate/Pagination.svelte";
	import { totalRecords } from "src/store/store";
	import LoaderContainer from "../Loader/LoaderContainer.svelte";
	import CustomTableMasterData from "./CustomTableMasterData.svelte";
	import CustomTableIndex from "./CustomTableIndex.svelte";

	export let columns = [];
	export let rows = [];
	export let emptyMessage = "No data to display";

	let sortColumn = "";
	let sortDirection = 0; // 0 for ascending, 1 for descending

	const dispatch = createEventDispatcher();

	function toggleSort(column, callback) {
		const url = new URL(window.location.href);
		let urlSortDir = url.searchParams.get("sortDir");
		if (sortColumn === column) {
			sortDirection =
				urlSortDir !== null
					? Number(urlSortDir) === 0
						? 1
						: 0
					: sortDirection === 0
					? 1
					: 0;
		} else {
			sortDirection = urlSortDir !== null ? Number(urlSortDir) : 0;
		}
		sortColumn = column;
		dispatch("sort", { column, direction: sortDirection });

		url.searchParams.set("sortCol", sortColumn);
		url.searchParams.set("sortDir", sortDirection);
		window.history.pushState({}, "", url);
		callback();
	}

	let columnComponents = {
		link: CustomTableLink,
		actions: CustomTableActions,
		date: CustomTableDate,
		status: CustomTableStatus,
		masterdata: CustomTableMasterData,
		index: CustomTableIndex,
	};
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				{#each columns as { label, key, type, sortCol, event }}
					<th>
						{label}
						{#if type === "date"}
							<i
								role="button"
								on:click={() => toggleSort(sortCol, event)}
								>{#if sortDirection === 0 && sortColumn === sortCol}
									<img
										src="/assets/icon-sort-up-thin.svg"
										alt="icon-sort-up"
									/>
								{:else}
									<img
										src="/assets/icon-sort-down-thin.svg"
										alt="icon-sort-down"
									/>
								{/if}
							</i>
						{/if}
					</th>
				{/each}
			</tr>
		</thead>
		<tbody>
			{#each rows as row, index}
				<tr on:click={() => dispatch("rowClick", row)}>
					{#each columns as { key, type, event, action, options }}
						<td>
							{#if columnComponents[type]}
								<svelte:component
									this={columnComponents[type]}
									{row}
									{key}
									{event}
									{action}
									{options}
									index={index + 1}
								/>
							{:else}
								{row[key] || "-"}
							{/if}
						</td>
					{/each}
				</tr>
			{/each}
			{#if rows.length === 0}
				<tr>
					<td colspan={columns.length} class="text-center empty-message">
						{emptyMessage}
					</td>
				</tr>
			{/if}
		</tbody>
	</Table>
</LoaderContainer>
<Pagination totalRecord={$totalRecords} />

<style>
	.empty-message{
		font-weight: bold;
	}
</style>